import React, { Fragment } from "react";
import { Tooltip, IconButton } from "@mui/material";

import CheckBoxOutlineBlankRoundedIcon from "@mui/icons-material/CheckBoxOutlineBlankRounded";
import CheckBoxRoundedIcon from "@mui/icons-material/CheckBoxRounded";

const ExportedButton = ({ ...props }) => {
  const { handleToggleExport, isExported, packageId, userId } = props;

  return (
    <Fragment>
      {isExported && (
        <Tooltip
          title="Mark as Not Exported"
          onClick={(e) => handleToggleExport(e, packageId, userId)}
        >
          <IconButton aria-label="notExported" size="large">
            <CheckBoxRoundedIcon />
          </IconButton>
        </Tooltip>
      )}
      {!isExported && (
        <Tooltip
          title="Mark as Exported"
          onClick={(e) => handleToggleExport(e, packageId, userId)}
        >
          <IconButton aria-label="exported" size="large">
            <CheckBoxOutlineBlankRoundedIcon />
          </IconButton>
        </Tooltip>
      )}
    </Fragment>
  );
};

export default ExportedButton;
